(async function () {
  let ALLOWED = [];
  async function loadAllowed() {
    try {
      const res = await fetch('{{ "pincodes.json" | asset_url }}', { cache: "no-store" });
      const data = await res.json();
      ALLOWED = (data?.allowed || []).map(String.trim);
    } catch (e) { console.error("Pincode list missing or invalid", e); }
  }

  function normalize(code) {
    return (code || "").toString().replace(/\s+/g,"").toUpperCase();
  }
  function isAllowed(code) { return ALLOWED.includes(normalize(code)); }

  function showResult(el, ok) {
    if (!el) return;
    el.textContent = ok ? "Express Delivery is available for your pincode." : "";
    el.setAttribute("data-ok", ok ? "true" : "false");
  }

  function attachProductWidget() {
    document.querySelectorAll("[data-pincode-check]").forEach(wrapper => {
      if (wrapper.dataset.bound === "1") return;
      wrapper.dataset.bound = "1";
      const input = wrapper.querySelector("input[type='text']");
      const btn   = wrapper.querySelector("button");
      const out   = wrapper.querySelector("[data-pincode-result]");
      btn?.addEventListener("click", e => {
        e.preventDefault();
        const ok = isAllowed(input?.value);
        showResult(out, ok);
        // optionally disable Add to cart if not allowed
        const add = document.querySelector("form[action*='/cart/add'] [type='submit']");
        if (add) add.disabled = !ok;
      });
    });
  }

  function attachCartGuard() {
    // read any previously saved pincode
    const saved = window.localStorage.getItem("customer_pincode") || "";
    const cartInput = document.querySelector("[data-cart-pincode] input");
    const cartOut   = document.querySelector("[data-cart-pincode] [data-pincode-result]");
    if (cartInput && saved) cartInput.value = saved;

    // block checkout if invalid
    document.querySelectorAll("form[action='/cart'] [name='checkout'], a[href*='/checkouts/'], button[name='checkout']").forEach(btn => {
      btn.addEventListener("click", (e) => {
        const code = (cartInput?.value || saved || "").trim();
        const ok = isAllowed(code);
        if (!ok) {
          e.preventDefault();
          e.stopPropagation();
          showResult(cartOut || document.querySelector("[data-pincode-global]"), false);
          alert("Jambox Delivery isn’t available for your pincode. Please use a different shipping method or change pincode.");
        } else {
          window.localStorage.setItem("customer_pincode", code);
          // add cart note with pincode for staff visibility
          const note = document.querySelector("textarea[name='note']");
          if (note && !/Pincode:/i.test(note.value)) note.value += (note.value ? "\n" : "") + "Pincode: " + code;
        }
      });
    });
  }

  await loadAllowed();
  attachProductWidget();
  attachCartGuard();
})();
